import { styled } from '@linaria/react'
import { AvatarStyled } from 'atoms/Avatar'
import { InputLabel } from 'atoms/Input'
import { TextBoxSC, TextBoxTypes } from 'atoms/TextBox'
import { ButtonGroupWrapper } from 'blocks/ButtonGroup'
import { COLOR } from 'vars/color'
import { FIXED_INDENTS } from 'vars/fixed-indents'
import { MEDIA } from 'vars/media'

export const RemoveProfileSC = styled.div`
  gap: var(${FIXED_INDENTS.INDENT_60});
  height: 100%;
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: max-content 1fr;
  justify-items: center;
  gap: var(${FIXED_INDENTS.INDENT_60});
  padding: var(${FIXED_INDENTS.INDENT_120});

  ${MEDIA.MIN_600} {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  ${MEDIA.MIN_1240_OR_LANDSCAPE} {
    padding: 0;
    height: initial;
    flex-direction: row;
    justify-content: initial;
    gap: var(${FIXED_INDENTS.INDENT_120});
  }

  ${MEDIA.MIN_1240} {
    gap: var(${FIXED_INDENTS.INDENT_220});
  }

  ${AvatarStyled} {
    width: 96px;
    height: 96px;

    ${MEDIA.MIN_1240} {
      width: 116px;
      height: 116px;
    }
  }
`

export const RemoveProfileWrapper = styled.div`
  ${MEDIA.MAX_599} {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: var(${FIXED_INDENTS.INDENT_40});
  }
`

export const RemoveProfileContentSC = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(${FIXED_INDENTS.INDENT_60});
  max-width: var(--formMaxWidth);
  flex: 1;

  ${MEDIA.MAX_599} {
    display: grid;
    grid-template-rows: max-content 1fr;
    gap: var(${FIXED_INDENTS.INDENT_50});
    height: 100%;
  }

  ${InputLabel} {
    gap: var(${FIXED_INDENTS.INDENT_40});

    ${MEDIA.MAX_599} {
      gap: var(${FIXED_INDENTS.INDENT_20});
    }

    ${TextBoxSC} {
      font: var(${TextBoxTypes.Headline3});
      color: var(${COLOR.TEXT_ICON_PRIMARY});
    }
  }

  ${ButtonGroupWrapper} {
    display: grid;
    gap: var(${FIXED_INDENTS.INDENT_30});
    margin-top: auto;
    grid-template-columns: 1fr;
    grid-template-rows: 1fr 1fr;

    ${MEDIA.MIN_600} {
      width: 100%;
      grid-template-columns: 1fr 1fr;
      grid-template-rows: 1fr;
      margin-top: var(${FIXED_INDENTS.INDENT_120});
    }

    ${MEDIA.MIN_1240_OR_LANDSCAPE} {
      gap: var(${FIXED_INDENTS.INDENT_20});
      margin-top: var(${FIXED_INDENTS.INDENT_80});
    }
  }
`
